export const ModalAddAvatarTranslationsEn = {
  'Add profile picture': 'Add profile picture',
};
